import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslationService } from 'src/app/my-sedgwick';
import { TranslationRequest } from '../models/translation/translation-request';

@Injectable()
export class CustomDatepickerIntl extends MatDatepickerIntl {
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  constructor(private translationService: TranslationService) {
    super();

    this.translationService.getTranslationForKey$('Previous month', this.translationRequest).subscribe((translation) => {
      this.prevMonthLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Next month', this.translationRequest).subscribe((translation) => {
      this.nextMonthLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Previous year', this.translationRequest).subscribe((translation) => {
      this.prevYearLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Next year', this.translationRequest).subscribe((translation) => {
      this.nextYearLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Open calendar', this.translationRequest).subscribe((translation) => {
      this.openCalendarLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Close calendar', this.translationRequest).subscribe((translation) => {
      this.closeCalendarLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Switch to month view', this.translationRequest).subscribe((translation) => {
      this.switchToMonthViewLabel = translation;
      this.changes.next();
    });

    this.translationService.getTranslationForKey$('Switch to year view', this.translationRequest).subscribe((translation) => {
      this.switchToMultiYearViewLabel = translation;
      this.changes.next();
    });
  }
}
